import {
  take,
  fork,
  put,
} from 'redux-saga/effects';
import { push } from 'connected-react-router';

import { sagasManager } from '../../utils';
import { uiTypes } from '.';

function* displayErrorPage() {
  while (true) {
    yield take(uiTypes.DISPLAY_ERROR_PAGE);
    yield put(push('/page-not-found'));
  }
}

function* goBackFromErrorPage() {
  while (true) {
    yield take(uiTypes.GO_BACK_FROM_ERROR_PAGE);
    let goBackUrl = '/';
    if (localStorage.getItem('authToken')) {
      goBackUrl = '/projects/';
    }
    yield put(push(goBackUrl));
  }
}


sagasManager.addSagaToRoot(function* watcher() {
  yield fork(displayErrorPage);
  yield fork(goBackFromErrorPage);
});
